import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const OfficeLabelCell = ({label}) => {
  const {t} = useTranslation('company');
  return t(label);
};

export default OfficeLabelCell;

OfficeLabelCell.propTypes = {
  label: PropTypes.string,
};

export const renderLabel = (text) => {
  return <OfficeLabelCell label={text} />;
};